import type { JobsSearchFranchiseOfficeResponse } from "./types/jobs-search-response";

import { marketingApiGet } from "./marketing-api-get";

type SearchJobsOptions = {
  maxJobsPerOffice?: number;
};

async function searchJobs(
  searchQuery: string,
  options: SearchJobsOptions = {},
): Promise<JobsSearchFranchiseOfficeResponse[]> {
  const trimmedQuery = searchQuery.trim();
  if (!trimmedQuery) {
    return [];
  }

  const searchParams = new URLSearchParams({
    searchQuery: trimmedQuery,
  });

  if (options.maxJobsPerOffice !== undefined) {
    searchParams.set("maxJobsPerOffice", String(options.maxJobsPerOffice));
  }

  return marketingApiGet<JobsSearchFranchiseOfficeResponse[]>({
    emptyValue: [],
    logContext: { searchQuery: trimmedQuery },
    logMessage: "Failed to fetch jobs search from hi-marketing-api",
    logTags: { component: "JobSearchResultSection" },
    mapResponse: (response) =>
      response === null
        ? []
        : (response as JobsSearchFranchiseOfficeResponse[]),
    path: `/api/v1/jobs/search?${searchParams.toString()}`,
  });
}

export { searchJobs };
